<template>
  <div class="form-group mb-3">
    <p>
      <label>选择问题分类</label>
    </p>
    <div>
      <template v-if="c_isShowTagsSpinner">
        <a
          href="javascript:undefined"
          class="qa-taglist font-weight-bold"
          style="letter-spacing: 0.5em"
        >
          {{ c_tagSpinner }}
        </a>
      </template>
      <template v-if="!c_isShowTagsSpinner">
        <a
          href="javascript:undefined"
          class="qa-taglist"
          :class="`${ms_selectedTagId === tag.tagId ? 'active' : ''}`"
          :id="`qa-tags-tag-${tag.tagId}`"
          :disabled="isWaitingQaQuestionAskTags"
          @click.prevent="selectTag(tag)"
          :key="tag.tagId"
          v-for="tag in ms_qAskTags"
          >{{ tag.tagName }}</a
        >
      </template>
    </div>
    <p class="text-orange small" v-if="!mg_isSelectedTag">
      温馨提示：提问时请选择项目/级别和学科，可以更快匹配到答疑老师哦！
    </p>
    <div v-if="mg_isNeedSubTag">
      <hr />
      <a
        href="javascript:undefined"
        class="qa-taglist"
        :class="`${ms_selectedSubTagId === subTag.tagId ? 'active' : ''}`"
        :id="`qa-tags-sub-tag-${subTag.tagId}`"
        @click.prevent="selectSubTag(subTag)"
        :key="subTag.tagId"
        v-for="subTag in mg_selectedTag.subTags"
        >{{ subTag.tagName }}</a
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
//import _ from 'lodash';

import { QaSwalMixin } from '@/mixins/QA/QaSwal';
import { QaTagsModelMixin } from '@/mixins/QA/Tags/model';

const GetQaQuestionAskTagsMixin = {
  name: 'GetQaQuestionAskTagsMixin',

  data() {
    return {
      promiseGetQaQuestionAskTags: null,
      isWaitingQaQuestionAskTags: false,
    };
  },

  methods: {
    ...mapActions('Mixins/QA', {
      ma_getQaQuestionAskTags: 'getQaQuestionAskTags',
    }),

    async getQaQuestionAskTags() {
      this.isWaitingQaQuestionAskTags = true;
      this.promiseGetQaQuestionAskTags = this.ma_getQaQuestionAskTags();
      await this.promiseGetQaQuestionAskTags;
      this.isWaitingQaQuestionAskTags = false;
    },
  },

  created() {
    this.getQaQuestionAskTags();
  },
};

// QaTagsModelMixin, GetQaQuestionAskTagsMixin
const ShowTagSpinnerMixin = {
  name: 'ShowTagSpinnerMixin',

  data() {
    return {
      qtyEllipsis: 3,
    };
  },

  computed: {
    c_isShowTagsSpinner() {
      return this.isWaitingQaQuestionAskTags && 0 === this.ms_qAskTags.length;
    },

    c_tagSpinner() {
      return '·········'.substring(this.qtyEllipsis);
    },
  },

  methods: {
    async showTagsSpinner() {
      if (0 === this.ms_qAskTags.length) {
        const itvl = setInterval(() => {
          this.qtyEllipsis = this.qtyEllipsis > 0 ? this.qtyEllipsis - 1 : 6;
        }, 100);
        await this.promiseGetQaQuestionAskTags;
        clearInterval(itvl);
      }
    },
  },

  created() {
    this.showTagsSpinner();
  },
};

// QaTagsModelMixin
const SelectTagsMixin = {
  name: 'SelectTagsMixin',

  mixins: [QaSwalMixin],

  methods: {
    selectTag(tag) {
      if (!tag.canPostQA) {
        this.swalNotCanPostQA();
        return;
      }
      if (this.ms_selectedTagId !== tag.tagId) {
        this.mm_SET_SELECTED_TAG_ID(tag.tagId);
        this.mm_SET_SELECTED_SUBTAG_ID(-1);
      }
    },

    selectSubTag(subTag) {
      if (this.ms_selectedSubTagId !== subTag.tagId) {
        this.mm_SET_SELECTED_SUBTAG_ID(subTag.tagId);
      }
    },
  },
};

export default {
  name: 'qa-tags',

  mixins: [
    //
    QaTagsModelMixin,
    GetQaQuestionAskTagsMixin,
    ShowTagSpinnerMixin,
    SelectTagsMixin,
  ],
};
</script>
<style lang="scss" scoped></style>
